//deps
import React, { memo } from "react";

//styles
import { IColors, ITypography } from "@swiggy-private/dls-web-common/dist/components/types";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { CardNumberSubNameContainer, Dot } from "./styles/CardNumberSubname.style";

interface CardNumberSubnameProps {
    cardNumber: string;
    textVariant?: keyof ITypography;
    textColor?: keyof IColors;
    showDivider?: boolean;
    bulletRadius?: number;
    isTurboPaymentMethod: boolean;
    dotLength?: number;
    isTurboV2?: boolean;
}

function CardNumberSubname({
    cardNumber,
    textVariant = "V2.body1.neutral.bold",
    textColor,
    showDivider = true,
    bulletRadius = 3,
    dotLength = 4,
    isTurboPaymentMethod,
    isTurboV2 = false,
}: CardNumberSubnameProps) {
    return (
        <CardNumberSubNameContainer
            showDivider={showDivider}
            isTurboV2={isTurboV2}
            isTurboPaymentMethod={isTurboPaymentMethod}
        >
            {Array.from({ length: dotLength }, (_, i) => (
                <Dot
                    isLastElement={i == dotLength - 1}
                    dotRadius={bulletRadius}
                    key={i}
                    isTurboPaymentMethod={isTurboPaymentMethod}
                />
            ))}
            <Text
                variant={isTurboPaymentMethod ? textVariant : "V2.body2.neutral.medium"}
                color={isTurboPaymentMethod ? textColor : "text_High_Emphasis"}
            >
                {cardNumber}
            </Text>
        </CardNumberSubNameContainer>
    );
}

export default memo(CardNumberSubname);
